/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecordCompletedJourneyBatchRequest} from '@cash-web/protos/squareup/cash/blockuserjourneys/api/v1/service.pb'
import {RecordCompletedJourneyBatchResponse} from '@cash-web/protos/squareup/cash/blockuserjourneys/api/v1/service.pb'


export const recordCompletedJourneyBatch = (request:RecordCompletedJourneyBatchRequest, options?: CashRequestOptions) => post<RecordCompletedJourneyBatchRequest, RecordCompletedJourneyBatchResponse>("/2.0/cash/record-completed-journey-batch", request, {...options, rejectOnError: true })